import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import WrappedMenu from '../../../../components/Menu'
import { translate } from 'react-i18next'
import './Navbar.css'
import {FileText} from 'lucide-react'
import { toastr } from 'react-redux-toastr'
import {translateName} from "../../../../utils/i18n";
import FilePreviewAndDownload from "../../../../components/filePreviewAndDownload";
import { PLATFORM_MEDIA_ACCESS_ID } from "../../../../utils/network";

class Docs extends Component {

    render() {
        const { docsOpened, setDocsOpened, documents, color, language, groupModel } = this.props

        return (
            <div
                className={classnames('dropdown', {
                    open: docsOpened
                })}
            >
                <button
                    className="navbar-icon-container"
                    onClick={() => setDocsOpened(!docsOpened)}
                >
                    <FileText className="navbar-icon documents-icon" color={color}/>
                </button>
                <WrappedMenu
                    opened={docsOpened}
                    onClickOutside={() => setDocsOpened(false)}
                    outsideClickIgnoreClass={'documents-icon'}
                    position="left"
                >
                    <ul
                        className="Navbar-Menu-list"
                        aria-labelledby="dropDownMenuDocs"
                    >
                        {documents.map((doc, index) => (
                                <li key={doc.documentsToShowInNavBar[0]?.id} className="Navbar-Menu-item" style={{justifyContent: 'space-between'}}>
                                    <a>
                                        {translateName(doc.title, language)}
                                    </a>
                                    <FilePreviewAndDownload
                                        file={doc.documentsToShowInNavBar[0]}
                                        files={doc.documentsToShowInNavBar}
                                        language={language}
                                        groupModel={groupModel}
                                        accessId={PLATFORM_MEDIA_ACCESS_ID}
                                        forceDisplayPreviewButton={true}
                                        showDownloadMenu={true}
                                        style={{marginLeft: 'auto'}}
                                    >
                                    </FilePreviewAndDownload>
                                    {/*index !== documents.length - 1  && <p className='divider'/>*/}
                                </li>
                            )
                        )}
                    </ul>
                </WrappedMenu>
            </div>
        )
    }
}

Docs.propTypes = {
    language: PropTypes.string.isRequired,
    docsOpened: PropTypes.bool.isRequired,
    setDocsOpened: PropTypes.func.isRequired
}

export default translate('platform')(Docs)
